import { LabelSource } from '@/api/generatedApi';
import { getDepthColor } from '@/pages/TaxonomyPage/TaxonomyTree/taxonomyTreeConstants';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Label } from '@mui/icons-material';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { useRef, useState } from 'react';

export const ReadOnlyLabelChip = ({ name, depth, source }: { name: string; depth: number; source?: LabelSource }) => {
  const color = getDepthColor(depth);
  const [isTruncated, setIsTruncated] = useState(false);
  const labelReference = useRef<HTMLSpanElement>(null);

  const checkTruncation = () => {
    if (labelReference.current) {
      setIsTruncated(labelReference.current.scrollWidth > labelReference.current.clientWidth);
    }
  };

  const showAiBadge = source === LabelSource.PhysnaGenerated;

  return (
    <Tooltip title={isTruncated ? name : ''} arrow>
      <Chip
        icon={<Label sx={{ fontSize: 14, color: `${color} !important` }} />}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden' }}>
            <Typography
              ref={labelReference}
              variant='body2'
              onMouseEnter={checkTruncation}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '0.8125rem',
                lineHeight: 'inherit',
              }}
            >
              {name}
            </Typography>
            {showAiBadge && (
              <Tooltip title='Auto-generated by Physna AI' arrow>
                <AutoAwesomeIcon sx={{ fontSize: 12, color: 'secondary.main', flexShrink: 0 }} />
              </Tooltip>
            )}
          </Box>
        }
        size='small'
        variant='outlined'
        sx={{
          borderColor: color,
          color: 'text.primary',
          '& .MuiChip-label': { px: 0.75, overflow: 'hidden' },
          height: 24,
          maxWidth: '100%',
        }}
      />
    </Tooltip>
  );
};
